var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3459_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1914 14.6484C12.5574 15.0144 12.5574 15.6082 12.1914 15.9742C11.8254 16.3402 11.2316 16.3402 10.8656 15.9742L6.24999 11.3242L1.60155 15.9727C1.23558 16.3386 0.641787 16.3386 0.275771 15.9727C-0.0902441 15.6067 -0.0902051 15.0129 0.275771 14.6469L4.92577 10L0.274482 5.3164C-0.0914941 4.95043 -0.0914941 4.35664 0.274482 3.99062C0.640459 3.62461 1.23425 3.62465 1.60026 3.99062L6.24999 8.67578L10.8984 4.02734C11.2644 3.66136 11.8582 3.66136 12.2242 4.02734C12.5902 4.39332 12.5902 4.98711 12.2242 5.35312L7.57421 10L12.1914 14.6484Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3459_4576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.43a275631434648c02cd3c3c6d314a09.svg";
export { ForwardRef as ReactComponent };